import React from 'react';
import { JsonEditor as Editor } from 'jsoneditor-react';
import './jsonEditor.css';
import ace from 'brace';
import 'brace/mode/json';
import 'brace/theme/github';

const JsonEditor = (props: any) => {
  const handleEdit = (data: any) => {
    if (props.view) return false;
    else return true;
  };

  return (
    <Editor
      ref={props.setRef}
      id={props.id}
      value={props.data}
      mode={props.mode ? props.mode : 'view'}
      onChange={props.handleChange}
      ace={ace}
      onEditable={handleEdit}
      theme="ace/theme/github"
      enableSort={false}
      enableTransform={false}
      search={true}
      allowedModes={props.allowedModes ? props.allowedModes : ['view', 'code']}
      statusBar={false}
      htmlElementProps={{
        style: {
          height: '60vh',
          marginTop: '35px'
        }
      }}
    />
  );
};

export default JsonEditor;
